import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import styled from "styled-components";
import IcomoonReact from "icomoon-react";
import iconSet from "../../fonts/selection.json";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "auto",
    maxWidth: "90vw",
    maxHeight: "90vh",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #dddddd",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Image = styled.img`
  width: auto;
  height: auto;
  max-width: calc(90vw - 40px);
  max-height: calc(90vh - 40px);
`;

const ImageContainer = styled.div`
  position: relative;
`;
const Close = styled.span`
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  width: 46px;
  height: 46px;
  background-color: #ddd;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Lightbox = ({ activeImage, setActiveImage }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setActiveImage(null);
  };

  useEffect(() => {
    if (activeImage) {
      handleOpen();
    }
  }, [activeImage]);

  const body = (
    <>
      <Close onClick={handleClose}>
        <IcomoonReact
          iconSet={iconSet}
          color={"#fff"}
          icon={"close"}
          size={25}
        />
      </Close>
      <div className={classes.paper}>
        <ImageContainer>
          <Image src={activeImage} />
        </ImageContainer>
      </div>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
    >
      {body}
    </Modal>
  );
};

export default Lightbox;
